<template lang="pug">
  .mx-auto.heading
    h1.acg-heading.text-center {{title}}
    p.description.mx-auto.body-1.text-center(v-html="description")
    div.details(v-if="showDetails").d-flex.flex-column.align-center
      div
        p.body-2.ma-0.d-flex.flex-wrap(v-if="s3Details")
          strong Last Updated:
          span.pl-2 {{format(s3Details.LastModified)}}
        p.body-2.ma-0.d-flex.flex-wrap(v-if="numberOfRecords")
          strong Number of Records:
          span.pl-2 {{numberOfRecords ? numberOfRecords.toLocaleString() : '-'}}
        p.body-2.ma-0.d-none.align-center
          strong Popularity:
          v-progress-linear(:value="popularity" height="10px").mx-2
      .d-flex.justify-space-around.align-center.pt-3
        div.mx-2(v-if="download")
          v-tooltip(bottom color="secondary" max-width="450px")
            template(v-slot:activator="{ on }")
              v-btn(color="primary" height="50" :href="downloadUrl" download v-on="on" aria-label="Download").d-flex
                v-icon mdi-download
                span.text-center.d-none.d-sm-inline.mx-2.font-weight-bold DOWNLOAD DATASET<br/>
                  span(v-if="filesize").font-weight-light.ml-1 (SIZE: {{filesizeString}} - .{{fileExtension}} FILE EXT)
            span {{fileExtensionTooltip}}
        div.mx-2(v-if="url")
          v-tooltip(bottom color="secondary" )
            template(v-slot:activator="{ on }")
              v-btn(color="primary" height="50" :href="apiUrl" v-on="on" target="_blank" aria-label="View Raw Data").d-flex
                v-icon mdi-code-json
                span.text-center.d-none.d-sm-inline.mx-2.font-weight-bold VIEW API<br/>
                  span().font-weight-light.ml-1 (JSON FORMAT)
            span View Raw Data
        div.mx-2(v-if="extUrl")
          v-btn(color="primary" height="50" :href="extUrl" target="_blank" aria-label="View External Dataset").d-flex
            v-icon mdi-web
            span.text-center.d-none.d-sm-flex.flex-column.mx-2.font-weight-bold VIEW EXTERNAL<br/>DATASET
    div.view-details(v-if="showViewDetails")
      v-textarea(
        label="API URL"
        v-model="apiUrl"
        readonly
        outlined
        auto-grow
        hide-details
        no-resize
        rows=1
      )
        template(v-slot:append)
          tooltip-btn(label="Copy to clipboard" icon="mdi-clipboard-text-outline" position="left" large v-clipboard="apiUrl" @click.prevent)
        template(v-slot:append-outer)
          tooltip-btn(v-if="queryExplanation" :label="'Query: ' + queryExplanation" icon="mdi-help-circle-outline" position="left" tooltip-color="secondary" color="orange" large)
    div(v-if="showApiUrl && url")
      v-textarea(
        label="API URL"
        v-model="apiUrl"
        readonly
        outlined
        dense
        rows=2
      )
        template(v-slot:append)
          tooltip-btn(label="Copy to clipboard" icon="mdi-clipboard-text-outline" position="left" large v-clipboard="url" @click.prevent)
</template>

<script>
import filesize from 'filesize'
import moment from 'moment'
import TooltipBtn from './TooltipBtn.vue'

export default {
  components: { TooltipBtn },
  props: {
    title: String,
    description: String,
    queryExplanation: String,
    s3Details: Object,
    numberOfRecords: Number,
    url: String,
    download: String,
    filesize: Number,
    extUrl: String,
    showDetails: Boolean,
    showViewDetails: Boolean,
    showApiUrl: Boolean,
    token: String
  },
  methods: {
    format(datetime, format='LLL') {
      return moment(datetime).format(format)
    }
  },
  computed: {
    downloadUrl() {
      return this.download + "?v=" + (this.s3Details ?  moment(this.s3Details.LastModified).unix() : moment().unix());
    },
    apiUrl() {
      let query = {}
      if (this.url.includes('datahub-v2-s3') || this.url.includes('download.data.arlingtonva.us'))
        query.v = (this.s3Details ?  moment(this.s3Details.LastModified).unix() : moment().unix());
      if (this.token)
        query.token = this.token

      if (Object.keys(query).length > 0)
        return `${this.url}?${Object.entries(query).map(([key, value]) => `${key}=${value}`).join('&')}`
      else
        return this.url
    },
    formattedUrl() {
      if(this.url)
        return this.url
          .replace(/^.*:\/\//, "")
          .replace(/\//g, " /\n")
          .replace(/\?/g, " ?\n\t")
          .replace(/&/g, " &\n\t")
      else
        return this.url
    },
    popularity() {
      if(this.description)
        return this.description.length%100
      else
        return 0
    },
    fileExtension() {
      return this.download && this.download.split('.').pop();
    },
    fileExtensionTooltip() {
      if (this.fileExtension === 'txt') {
        return 'This file type is pipe (|) delimited. To extract and view information, download the file and then import it in a program like MS Excel with pipe (|) as the delimiter.'
      } else if (this.fileExtension === 'gz') {
        return '.gz (Gzip) extension are compressed files stored to optimize storage and download size. To extract and view information, download the file and then decompress using program like 7-zip (https://www.7-zip.org/). View documentation for additional information.'
      }
      else return 'Click to download dataset. To view information on how to use this file type, visit documentation.'
    },
    filesizeString() {
      return filesize(this.filesize)
    }
  }
}
</script>

<style lang="stylus">
.heading
  .description
    max-width:700px
  .v-text-field.v-text-field--enclosed
    .v-input__append-inner, .v-input__append-outer
      margin-top: 8px
  .v-textarea.v-text-field--enclosed.v-text-field--outlined
    textarea
      margin-bottom:12px
</style>
